import React from 'react'
import { Tab, Button } from '@alifd/next'
import styles from './index.module.scss'
import { qc } from 'portal/assets/images'

interface QCItemProps {
  key: number,
  tab: string,
  title: string,
  summary1: string,
  summary2: string,
  summary3: string,
  qc: string,
}
export default function QualityControl() {
  const tabs: QCItemProps[] = [
    {
      key: 0,
      tab: '事前质控',
      title: '诊疗规范培训与认证',
      summary1: '以不断更新的科研成果支撑诊疗实践',
      summary2: '临床研究是临床诊疗技术向临床转化的关键步骤。',
      summary3: '针对呼吸领域临床医生和相关科研人员开展基于临床研究成果的规范化培训，拓展他们的知识背景，有助于促进科研成果在诊疗流程中的应用，最终改善诊疗服务质量。',
      qc,
    },
    {
      key: 1,
      tab: '事中质控',
      title: '临床决策支持',
      summary1: '临床观察与临床知识的高效链接',
      summary2: '临床指南的科学性和规范性为临床决策支持系统提供了可靠的知识来源，为医疗质量提供了保障。',
      summary3: '该系统的应用可以有效解决临床医生知识的局限性问题，减少人为疏忽，相对降低医疗费用。',
      qc,
    },
    {
      key: 2,
      tab: '事后质控',
      title: '诊疗流程数据分析',
      summary1: '基于KPI的考核分析，综合评价诊疗水平',
      summary2: '通过对大量转归患者的诊疗流程信息进行统计分析，并将过程信息与质控标准进行对照，完成对医疗质量和医疗资源使用情况的评价。',
      summary3: '建立诊疗流程关键节点KPI体系，无需分析冗余信息，即可快速发现问题，生成应对方案。',
      qc,
    }
  ]

  function renderTab (props: QCItemProps) {
    const { key, tab, title, summary1, summary2, summary3, qc  } = props
    return (
      <Tab.Item key={ key } title={ tab }>
        <div className={ styles.content } data-flex="cross:center">
          <div className={ styles.leftContent } style={{ width: 580, height: 320, marginRight: 40 }} >
            <img style={{ width: '100%', height: '100%' }} src={ qc } alt=""/>
          </div>
          <div className={ styles.rightContent }>
            <h5 style={{ fontSize: 22, color: '#f0f3ff', margin: '24px 0' }}>{ title }</h5>
            <ul style={{ fontSize: 14, color: '#95a4bd', paddingLeft: 15 }}>
              <li>{ summary1 }</li>
              <li>{ summary2 }</li>
              <li>{ summary3 }</li>
            </ul>
            <div className={ styles.qcBtn } data-flex="dir:top">
              <a href="/apps/qc" target="_blank" rel="noopener noreferrer">
                <Button>中日友好医院VTE诊疗质量控制系统</Button>
              </a>
              <a href="https://cqms.cardpc.org/m/" target="_blank" rel="noopener noreferrer">
                <Button>中国基层呼吸规范化建设质量控制系统</Button>
              </a>
            </div>
          </div>
        </div>
      </Tab.Item>
    )
  }
  return (
    <div className={ styles.qualityControl }>
      <div style={{ width: 1200, height: 710, margin: 'auto' }}>
        <h2 style={{ color: '#fff', textAlign: 'center', fontSize: 32, paddingTop: 80, paddingBottom: 30, margin: 0 }}>诊疗质量控制体系<p></p></h2>
        <Tab defaultActiveKey="0" style={{ textAlign: 'center' }}>
          { tabs.map(renderTab) }
        </Tab>
      </div>
    </div>
  )
}
